import { render, staticRenderFns } from "./CreKokuban.vue?vue&type=template&id=629f8076&scoped=true&"
import script from "./CreKokuban.vue?vue&type=script&lang=js&"
export * from "./CreKokuban.vue?vue&type=script&lang=js&"
import style0 from "./CreKokuban.vue?vue&type=style&index=0&id=629f8076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f8076",
  null
  
)

export default component.exports